// src/app/redux/store.ts
'use client';
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slice/authSlice';
import aiSearchReducer from './slice/aiSearch';
import forgotPasswordReducer from './slice/forgotPassword';
import transactionReducer from './slice/transaction';
import notificationReducer from './slice/notifications';
import callReducer from './slice/callsSlice';
// import allRoomsCallReducer from './slice/allCallSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    aiSearch: aiSearchReducer,
    forgotScreen: forgotPasswordReducer,
    transaction: transactionReducer,
    notification: notificationReducer,
    call: callReducer,
    // allRoomsCall: allRoomsCallReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore socket in call state
        ignoredPaths: ['call.socket'], // Ignore socket in state
        ignoredActions: ['call/initializeSocket/fulfilled', 'call/setSocket'], // Ignore actions related to socket
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
